import { OPPORTUNITY_STATUSES, type OpportunityStatus } from "@/types/opportunity";

const SCHEDULE_READY: ReadonlySet<string> = new Set([
  "signed",
  "ordered",
  "in_process",
  "complete",
]);

export function isOpportunitySchedulingNotesEditable(status: OpportunityStatus | string): boolean {
  return !SCHEDULE_READY.has(status) && status !== "lost";
}

export function isScheduleReadyOpportunityStatus(status: string): boolean {
  return SCHEDULE_READY.has(status);
}

export const SCHEDULING_NOTES_MAX_LEN = 4000;

/** Guard for type narrowing when iterating statuses. */
export function isOpportunityStatus(value: string): value is OpportunityStatus {
  return (OPPORTUNITY_STATUSES as readonly string[]).includes(value);
}
